import React, { useEffect, useState } from 'react';
import '../css/wb_manage_media.css';
import '../css/delivery_notification.css';
import Plus from '../Assets/images/plus.png';
import { apiCall } from '../services/authServieces';
import { ClipLoader } from "react-spinners";

const DeliveryNotification = () => {
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [userData, setUserData] = useState([]);
  const [deliveryData, setDeliveryData] = useState([]);
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    fetchDeliveryData();
  }, []);

  const fetchDeliveryData = async () => {
    setLoading(true);
    try {
      let responseData = await apiCall({ endpoint: 'api/DeliveryNotification', method: 'GET' });
      if (responseData.success) {
        setUserData(responseData.user_data || []);
        setDeliveryData(responseData.data_all || []);
      } else {
        setUserData([]);
        setDeliveryData([]);
        alert('Failed to fetch data. Please try again.');
      }
    } catch (err) {
      console.log('Error in fetching data', err);
      alert('An error occurred while fetching data');
      setUserData([]);
      setDeliveryData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (userId, currentStatus) => {
    setLoading(true);
    try {
      // New status will be the opposite of current status
      const newStatus = currentStatus === 'active' ? 'deactive' : 'active';
      
      let responseData = await apiCall({ 
        endpoint: 'api/updateDeliveryStatus', 
        method: 'POST', 
        payload: { 
          userId: userId,
          status: newStatus 
        }
      });
      
      if (responseData.success) {
        // Update local state to reflect the change
        const updatedDeliveryData = deliveryData.map(item => {
          if (item.user_id === userId) {
            return { ...item, status: newStatus };
          }
          return item;
        });
        
        setDeliveryData(updatedDeliveryData);
        alert('Status updated successfully');
      } else {
        alert('Failed to update status. Please try again.');
      }
    } catch (err) {
      console.log('Error updating status', err);
      alert('An error occurred while updating status');
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    const errors = {};
    
    if (!selectedUser) {
      errors.user = 'Please select a user';
    }
    
    if (!mobileNumber) {
      errors.mobile = 'Please enter a mobile number';
    } else if (!/^\d{10}$/.test(mobileNumber)) {
      errors.mobile = 'Mobile number must be 10 digits';
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('userId', selectedUser);
      formData.append('mobileNumber', mobileNumber);

      let responseData = await apiCall({ 
        endpoint: 'api/addDeliveryNotification', 
        method: 'POST', 
        payload: formData 
      });
      
      if (responseData.success) {
        alert('Notification added successfully');
        setSelectedUser('');
        setMobileNumber('');
        document.getElementById('closeModal').click(); // Close the modal
        fetchDeliveryData(); // Refresh the table data
      } else {
        alert(responseData.message || 'Failed to add notification. Please try again.');
      }
    } catch (err) {
      console.log('Error in adding notification', err);
      alert('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleSelectUser = (e) => {
    setSelectedUser(e.target.value);
    if (formErrors.user) {
      setFormErrors({...formErrors, user: ''});
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    // Only allow digits
    if (/^\d*$/.test(value)) {
      setMobileNumber(value);
      if (formErrors.mobile) {
        setFormErrors({...formErrors, mobile: ''});
      }
    }
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <>
      <div className="Template_id_contian2">
        <h4 className="Head_title2">
          Delivery Notification
          <button className="add_btn2 WMadd_btn" data-bs-toggle="modal" data-bs-target="#Preview_modal">
            <img src={Plus} alt="img" /> Add
          </button>
        </h4>
        <div className="Template_id_Card2">
          <div className="table_contain">
            <table className="Table" id="Table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>User ID</th>
                  <th>User Name</th>
                  <th>User Email</th>
                  <th>User Mobile</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {deliveryData.length > 0 ? (
                  deliveryData.map((item, index) => (
                    <tr key={item.id || index}>
                      <td>{index + 1}</td>
                      <td>{item.user_id}</td>
                      <td>{item.user_name}</td>
                      <td>{item.user_email}</td>
                      <td>{item.mobile_number}</td>
                      <td>{formatDate(item.created_date)}</td>
                      <td>
  <label className="delivery-toggle-switch">
    <input
      type="checkbox"
      checked={item.status === 'active'}
      onChange={() => handleToggleStatus(item.user_id, item.status || 'deactive')}
      className="delivery-toggle-input"
    /> 
    <span className="delivery-toggle-slider"></span>
    <span className="delivery-toggle-label">
      {item.status === 'active' ? 'Active' : 'Inactive'}
    </span>
  </label>
</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center' }}>No data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="modal fade" id="Preview_modal" aria-labelledby="Preview_modal_Label" aria-hidden="true">
        <div className="modal-dialog maxW400">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-center w-100" id="Preview_modal_Label">Add Notification</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body p-0">
              <div className="Modal_Table_contain">
                <div className="FormGroup">
                  <label htmlFor="userSelect">Select User <span className="required_icon">*</span></label>
                  <select 
                    name="userSelect" 
                    id="userSelect" 
                    value={selectedUser} 
                    onChange={handleSelectUser}
                    className={formErrors.user ? 'error-border' : ''}
                  >
                    <option value="">---Select---</option>
                    {userData.map(user => (
                      <option key={user.user_id} value={user.user_id}>
                      {user.user_name ? `${user.user_name} (${user.user_id})` : user.user_id}

                      </option>
                    ))}
                  </select>
                  {formErrors.user && <div className="error-message">{formErrors.user}</div>}
                </div>
                
                <div className="FormGroup">
                  <label htmlFor="mobileNumber">Mobile Number <span className="required_icon">*</span></label>
                  <input 
                    type="text" 
                    id="mobileNumber" 
                    value={mobileNumber}
                    onChange={handleMobileChange}
                    maxLength={10}
                    placeholder="Enter 10 digit mobile number"
                    className={formErrors.mobile ? 'error-border' : ''}
                  />
                  {formErrors.mobile && <div className="error-message">{formErrors.mobile}</div>}
                </div>
                
                <div className="modal-buttons">
                  <button type='button' className='Modal_save_btn' onClick={handleSave}>Save</button>
                  <button type="button" id='closeModal' className="Modal_cancel_btn ms-2" data-bs-dismiss="modal" aria-label="Close">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {loading && (
        <div className="spinnerOverlay">
          <ClipLoader loading={loading} size={50} />
        </div>
      )}
    </>
  );
};

export default DeliveryNotification;